/* eslint-disable @typescript-eslint/no-unused-vars */
import { Badge } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { CommonTabs } from '../../../components/tabs';
import { getNeedManageSites, getSiteText } from '../../../lib/multi-site';
import { WindowEvent } from '../../../model';

import styles from './index.module.scss';

interface IProps {
  activeTab?: string;
}

export const SiteSwitchTab = (props: IProps) => {
  const location = useLocation();
  const history = useHistory();
  const [badge, setBadge] = useState<Record<string, number>>({});

  useEffect(() => {
    clearBadge();
  }, [location.pathname]);

  const clearBadge = () => {
    setBadge({});
  };

  const handleBadgeEvent = useCallback(
    (ev: CustomEvent<Record<string, number>>) => {
      const data = ev.detail || {};
      setBadge({ ...badge, ...data });
    },
    [badge]
  );

  useEffect(() => {
    window.addEventListener(
      WindowEvent.SiteTabBadge,
      handleBadgeEvent as EventListener
    );

    return () => {
      window.removeEventListener(
        WindowEvent.SiteTabBadge,
        handleBadgeEvent as EventListener
      );
    };
  }, [handleBadgeEvent]);

  return (
    <CommonTabs
      className={styles.siteTabs}
      activeKey={props.activeTab}
      items={getNeedManageSites().map((site) => {
        return {
          label: (
            <>
              {getSiteText(site)}
              {badge[site] ? (
                <Badge count={badge[site]} offset={[10, -15]}></Badge>
              ) : (
                ''
              )}
            </>
          ),
          key: site,
        };
      })}
      onChange={(activeKey) => {
        const params = new URLSearchParams(location.search);
        params.set('site', activeKey);
        const siteSearch = `?${params.toString()}`;
        history.push({
          pathname: location.pathname,
          search: siteSearch,
        });
      }}
    />
  );
};
